import { createContext } from 'react';

interface SelectedMenuContextType {
  selectedKey: string[];
  setSelectedKey: (value: string[]) => void;
}

export const SelectedMenuContext = createContext<SelectedMenuContextType | null>(null);
